export default {
  data () {
    return {
      vDeepAttributes: {},
      vDeepParentClassList: []
    }
  },
  computed: {
    vDeepClassList () {
      const vNodeData = this.$vnode.data
      const staticClassList = vNodeData.staticClass?.split?.(' ') || []
      const dynamicClasses = vNodeData.class
        ? (Array.isArray(vNodeData.class) ? vNodeData.class : [vNodeData.class])
        : []

      return [
        ...this.vDeepParentClassList,
        ...staticClassList,
        ...dynamicClasses
      ]
    }
  },
  methods: {
    initVDeep () {
      this.transferVDeepParentClassList()
      this.transferVDeepScopedId()
    },
    transferVDeepParentClassList () {
      this.vDeepParentClassList = this.$parent?.$el?.classList || []
    },
    transferVDeepScopedId () {
      const scopeAttr = this.$parent.$options._scopeId
      this.vDeepAttributes = scopeAttr ? { [scopeAttr]: '' } : {}
    },
    clearVDeep () {
      this.vDeepParentClassList = []
      this.vDeepAttributes = {}
    }
  }
}
